import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "../assets/swal.css";

/** Warna brand SenderWA */
const GW = {
  forest: "#0d4a36",
  leaf: "#1f7a57",
  fog: "#eef6f1",
  warnBg: "#fff8e6",
  warnInk: "#8a6d3b",
  warn: "#c47a12",
  dangerBg: "#fff5f5",
  danger: "#c62828",
  ink: "#10241c",
};

function resolveKind(color) {
  const c = String(color || "").toLowerCase();
  if (
    c.includes("red") ||
    c === "error" ||
    c.includes("c62828") ||
    c.includes("b42318") ||
    c.includes("d32f2f")
  ) {
    return "error";
  }
  if (
    c.includes("orange") ||
    c === "warning" ||
    c.includes("b45309") ||
    c.includes("ef6c00") ||
    c.includes("c47a12") ||
    c.includes("ff9800")
  ) {
    return "warning";
  }
  return "success";
}

const kindTheme = {
  success: {
    icon: "success",
    background: GW.fog,
    color: GW.forest,
    iconColor: GW.leaf,
  },
  warning: {
    icon: "warning",
    background: GW.warnBg,
    color: GW.warnInk,
    iconColor: GW.warn,
  },
  error: {
    icon: "error",
    background: GW.dangerBg,
    color: GW.danger,
    iconColor: GW.danger,
  },
};

/**
 * Toast notifikasi (pengganti snackbar / alert).
 */
export function showAlert(text, color) {
  if (!text) return Promise.resolve();
  const kind = resolveKind(color);
  const theme = kindTheme[kind];

  return Swal.fire({
    toast: true,
    position: "top-end",
    icon: theme.icon,
    title: String(text),
    showConfirmButton: false,
    timer: 2800,
    timerProgressBar: true,
    background: theme.background,
    color: theme.color,
    iconColor: theme.iconColor,
    customClass: {
      popup: "gw-swal-toast",
      title: "gw-swal-toast__title",
    },
  });
}

/**
 * Dialog konfirmasi (pengganti confirm / dialog hapus).
 */
export function showConfirm(options = {}) {
  const {
    title = "Konfirmasi",
    text = "Lanjutkan tindakan ini?",
    confirmText = "Ya",
    cancelText = "Batal",
    danger = false,
  } = typeof options === "string" ? { text: options } : options;

  return Swal.fire({
    title,
    text,
    icon: danger ? "warning" : "question",
    showCancelButton: true,
    focusCancel: true,
    reverseButtons: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: danger ? GW.danger : GW.leaf,
    cancelButtonColor: GW.forest,
    background: "#fff",
    color: GW.ink,
    iconColor: danger ? GW.warn : GW.leaf,
    customClass: {
      popup: "gw-swal-modal",
      confirmButton: "gw-swal-btn",
      cancelButton: "gw-swal-btn",
      title: "gw-swal-modal__title",
    },
  }).then((result) => !!result.isConfirmed);
}

export { Swal, GW };
